/*
 * @Author: Chao Yang
 * @Date: 2020-09-04 10:18:35
 * @LastEditor: Chao Yang
 * @LastEditTime: 2020-09-10 08:43:17
 */
import { NgModule, ModuleWithProviders, Provider } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OverlayModule } from '@angular/cdk/overlay';
import { FormsModule } from '@angular/forms';
import {
  CalendarModule,
  DateAdapter,
  CalendarDateFormatter,
} from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { MonthPickerComponent } from './month-picker/month-picker.component';
import { YearPickerComponent } from './year-picker/year-picker.component';
import { DatePickerComponent } from './date-picker/date-picker.component';
import { DatePickerPopupComponent } from './date-picker-popup/date-picker-popup.component';
import { DateRangeComponent } from './date-range.component';
import { DateRangePopupComponent } from './date-range-popup/date-range-popup.component';
import { AdCalendarDateFormatter } from './ad-calendar-date-formatter.provider';
import { DATE_PICKER_CONFIG_DATA } from './date-picker-config-data';
import { DateRange_Fommat_CONFIG } from './date-range-format-config';
import { AdDateRangeEventService } from './ad-date-range-event.service';
import { CONFIG_DATA } from './ad-date-range-inject-key';
import { AdDateRangeModel } from './ad-date-range-model';
import { DateRangeTypeEnum } from './date-range-type.enum';
import { DateRangeToolbarComponent } from './date-range-toolbar.component';
import { DateRangeCommonComponent } from './date-range-common.component';

@NgModule({
  declarations: [
    MonthPickerComponent,
    YearPickerComponent,
    DatePickerComponent,
    DatePickerPopupComponent,
    DateRangeComponent,
    DateRangePopupComponent,
    DateRangeToolbarComponent,
    DateRangeCommonComponent,
  ],
  imports: [CommonModule, FormsModule, OverlayModule, CalendarModule],
  exports: [
    MonthPickerComponent,
    YearPickerComponent,
    DatePickerComponent,
    DatePickerPopupComponent,
    DateRangeComponent,
    DateRangePopupComponent,
    DateRangeToolbarComponent,
    DateRangeCommonComponent,
  ],
})
export class DateRangeModule {
  static forChild(providers: Provider[]): ModuleWithProviders<DateRangeModule> {
    return {
      ngModule: DateRangeModule,
      providers,
    };
  }

  static forRoot(providers: Provider[]): ModuleWithProviders<DateRangeModule> {
    return {
      ngModule: DateRangeModule,
      providers: [
        ...CalendarModule.forRoot(
          {
            provide: DateAdapter,
            useFactory: adapterFactory,
          },
          {
            dateFormatter: {
              provide: CalendarDateFormatter,
              useClass: AdCalendarDateFormatter,
            },
          }
        ).providers,
        ...providers,
      ],
    };
  }
}

// export {
//   DATE_PICKER_CONFIG_DATA,
//   DateRange_Fommat_CONFIG,
//   AdDateRangeEventService,
//   CONFIG_DATA,
//   AdDateRangeModel,
//   DateRangeTypeEnum,
// };
